import { render, staticRenderFns } from "./AverageVerification.vue?vue&type=template&id=5c7cb442"
import script from "./AverageVerification.vue?vue&type=script&lang=js"
export * from "./AverageVerification.vue?vue&type=script&lang=js"
import style0 from "./AverageVerification.vue?vue&type=style&index=0&id=5c7cb442&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports